import { toast } from 'sonner';
import { registerSW } from 'virtual:pwa-register';

/** De quanto em quanto tempo o tablet pergunta se há versão nova: ele fica dias aberto. */
const UMA_HORA = 60 * 60 * 1000;

/**
 * Registra o service worker da interface (Fase 43, RN-596).
 *
 * A versão nova não entra sozinha (RN-602): ela fica esperando, e o aviso oferece o
 * "Atualizar". Quem está no meio de uma conferência termina o que fazia e atualiza depois — a
 * página que recarrega sozinha levaria junto o que estava na caixa.
 *
 * O navegador só procura versão nova ao navegar, e o tablet do canteiro passa o dia na mesma
 * página. Daí a pergunta a cada hora.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  const atualizar = registerSW({
    onNeedRefresh() {
      toast('Há uma versão nova do ObraPlan.', {
        duration: Infinity,
        action: { label: 'Atualizar', onClick: () => void atualizar(true) },
      });
    },
    onRegisteredSW(_url, registro) {
      if (registro === undefined) return;
      setInterval(() => void registro.update(), UMA_HORA);
    },
  });
}
